module.exports = __webpack_public_path__ + "img/MUSA-13.b833dae6.jpg";